<template>
  <div
    :class="`single-features-item single-features-item-d ${style_3 ? 'single-features-item-d-2' : ''} ${style_2 ? 'b-radius-2' : 'b-radius'} mb-20`">
    <div class="row g-0 align-items-center">
      <div class="col-md-6">
        <div class="features-thum">
          <div class="features-product-image w-img">
            <router-link :to="`/shop-details/${product.id}`">
              <img style="width:200px;" :src="product.image" alt="">
            </router-link>
          </div>
          <div class="product__offer" v-if="product.discount_percentage">
            <span class="discount">-{{ product.discount_percentage }}%</span>
          </div>

          <!-- <div :class="`product-action ${style_2 ? 'product-action-2' : ''}`">
            <a href="#" class="icon-box icon-box-1" data-bs-toggle="modal" :data-bs-target="`#${utilityStore.modalId}`" @click.prevent="utilityStore.handleOpenModal(`product-modal-${product.id}`, product)">
              <i class="fal fa-eye"></i>
              <i class="fal fa-eye"></i>
            </a>
            <a href="#" @click.prevent="wishlistStore.add_wishlist_product(product)" :class="`icon-box icon-box-1 ${isItemInWishlist(product) ? 'active' : ''}`">
              <i class="fal fa-heart"></i>
              <i class="fal fa-heart"></i>
            </a>
            <a href="#" @click.prevent="compareStore.add_compare_product(product)" :class="`icon-box icon-box-1 ${isItemInCompare(product) ? 'active' : ''}`">
              <i class="fal fa-layer-group"></i>
              <i class="fal fa-layer-group"></i>
            </a>
          </div> -->
        </div>
      </div>
      <div class="col-md-6">
        <div class="product__content product__content-d">
          <h6><router-link :to="`/product-details/${product.id}`">{{ product.title }}</router-link></h6>

          <div v-if="product.discount_percentage > 0" class="price d-price mb-10">
            <span>{{ product.price }} - <del>{{ calculateOriginalPrice(product.price,
              product.discount_percentage).toFixed(2) }}</del></span>
          </div>
          <div v-else class="price d-price mb-10">
            <span>{{ product.price }}</span>
          </div>

          <div class="features-des mb-25">
            <ul>
              <li v-for="(list, i) in product.feature_lists" :key="i"><a href="#"><i class="fas fa-circle"></i>{{ list
                  }}</a></li>
            </ul>
          </div>
          <div class="cart-option">
            <a href="#" v-if="!isItemInCart(product)" @click.prevent="cartStore.addCartProduct(product)"
              :class="`${style_2 ? 'cart-btn-4' : 'cart-btn-2'} w-100 mr-10`">
            </a>
            <!-- <router-link to="/cart" v-if="isItemInCart(product)"
              :class="`${style_2 ? 'cart-btn-4' : 'cart-btn-2'} w-100 mr-10`">
              View Cart
            </router-link> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/useCartStore"
import { calculateOriginalPrice } from "@/utils/utils"
//import { useWishlistStore } from "@/stores/wishlistStore";
//import { useUtilsStore } from "@/stores/utilsStore";
//import { useCompareStore } from "@/stores/compareStore";

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({
      id: null,
      title: "",
      price: 0,
      discount_percentage: 0,
      image: "",
      feature_lists: [],
    }),
    },
  },
  data() {
    return {
      cartStore: useCartStore(),
      calculateOriginalPrice
      //wishlistStore: useWishlistStore(),
      //utilityStore: useUtilsStore(),
      //compareStore: useCompareStore(),
    }
  },
  methods: {
    isItemInWishlist(product) {
      return this.wishlistStore.wishlists.some((prd) => prd.id === product.id)
    },

    isItemInCart(product) {
      // Return true if the product exists in the cart
      return this.cartStore.cart_products.some((prd) => prd.id === product.id)
    },

    isItemInCompare(product) {
      return this.compareStore.compare_items.some((prd) => prd.id === product.id)
    },
    handleOpenModal(modalId, product) {
      this.utilityStore.handleOpenModal(modalId, product)
    },
  },
};
</script>
